<template>
  <section>
    <div class="columns">
      <div class="column has-text-right">
        <b-button
          :label="
            openedDetail.length === 0
              ? 'Expandir Observaciones'
              : 'Contraer Observaciones'
          "
          :icon-left="
            openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'
          "
          type="is-blue-color"
          @click="
            openedDetail.length === 0
              ? (openedDetail = performances)
              : (openedDetail = [])
          "
        />
      </div>
    </div>
    <b-table
      striped
      :data="
        performances.filter((x) => x.alt_name_area === academicArea.alt_name)
      "
      paginated
      per-page="10"
      :pagination-simple="false"
      pagination-position="bottom"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Página"
      aria-current-label="Página actual"
      detail-icon="plus-circle"
      :opened-detailed="openedDetail"
      detailed
    >
      <b-table-column
        field="commitment_index"
        label="N°"
        width="5%"
        v-slot="props"
      >
        {{ props.row.commitment_index }}
      </b-table-column>
      <b-table-column
        field="alt_name_activity"
        label="Actividad Académica"
        v-slot="props"
      >
        {{ props.row.alt_name_activity }}
      </b-table-column>
      <b-table-column
        v-if="
          academicArea.name === 'DOCENCIA' ||
          academicArea.name === 'EDUCACION CONTINUA'
        "
        field="alt_name_activity"
        label="Asignatura"
        v-slot="props"
      >
        {{
          (function () {
            if (props.row.subject_code == null || props.row.subject_code === "")
              return "";
            const filtered = subjects.filter(
              (subject) => parseInt(props.row.subject_code) === subject.codigo
            );
            return filtered.length > 0 ? filtered[0].codigo_nombre : "";
          })()
        }}
      </b-table-column>
      <b-table-column
        field="is_weekly_hours"
        label="Tipo de Hora"
        v-slot="props"
      >
        {{ props.row.is_weekly_hours ? "Semanales" : "Semestrales" }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_1"
        label="Horas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_2"
        label="Horas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_2 }}
      </b-table-column>
      <template #detail="props">
        <div class="content">
          <p><b>Observaciones: </b>{{ props.row.observations }}</p>
        </div>
      </template>
      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-warning">
              Aún no ha agregado Actividades para {{ academicArea.alt_name }}, a
              medida que agregue se irán mostrando en esta tabla.
            </b-message>
          </div>
        </div>
      </template>
    </b-table>
  </section>
</template>

<script>
export default {
  props: {
    performances: {
      type: Array,
      required: true,
    },
    academicArea: {
      type: Object,
      required: true,
    },
    subjects: {
      type: Array,
    },
  },

  data() {
    return {
      openedDetail: [],
    };
  },
};
</script>
